import React from 'react';

interface YoutubeVideoComponentProps {
  videoID: string;
}

const YoutubeVideo: React.FC<YoutubeVideoComponentProps> = ({ videoID }) => {
  return (
    <iframe
      width="800"
      height="450"
      className="max-w-full"
      src={`https://www.youtube.com/embed/${videoID}`}
      title="YouTube video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
    ></iframe>
  );
}

export default YoutubeVideo;